export default __webpack_public_path__ + "static/media/Brackets.eb1aeb82.gif";